export class GetNomenclaturesQuery {
	deviceTypeId: number;
	deviceSupplierName: string;
	deviceModelName: string;
	deviceConnectionTypeId: number;
}